@if (appStartupService.isInitializing()) {
  <div class="spinner-container">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
} @else {
  <router-outlet></router-outlet>
}
